"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[58219],{

/***/ 58219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Stories; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/LoaderRemote.js
var LoaderRemote = __webpack_require__(71593);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./themes/themes.js
var themes = __webpack_require__(89507);
;// CONCATENATED MODULE: ./components/StoriesItem.js



// import Lottie from "lottie-react";



var StoriesItem = function(param) {
    var url = param.url, title = param.title, icon = param.icon, index = param.index, animation = param.animation;
    //storyItemBorderColor
    var style = {
        height: 50,
        width: 50
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: url,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "flex flex-col items-center mr-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[4.25rem] h-[4.25rem] flex items-center justify-center border-2 rounded-full ".concat(themes/* default.storyItemBorderColor */.Z.storyItemBorderColor),
                    children: icon && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: title,
                        src: icon,
                        loader: LoaderRemote/* default */.Z,
                        width: 48,
                        height: 48,
                        objectFit: "contain",
                        objectPosition: "center",
                        placeholder: "blur",
                        blurDataURL: (0,LoaderRemote/* Blur */.x)(icon)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col text-center font-bold text-[0.688rem] mt-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: title
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_StoriesItem = (StoriesItem);

;// CONCATENATED MODULE: ./components/Stories.js



var Stories = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "block lg:hidden",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "overflow-x-auto flex flex-nowrap relative pb-4",
                    children: data && data.map(function(item, key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StoriesItem, {
                            url: item.url,
                            title: item.baslik,
                            icon: item.resim,
                            animation: item.animation,
                            index: key
                        }, key);
                    })
                })
            })
        })
    });
};
/* harmony default export */ var components_Stories = (Stories);


/***/ })

}]);